/*
This is not tested since it returns browser-specific stuff.
Since the unit testing environment is not in a browser,
we need to mock these return values.
 */
/**
 * Get the window object.
 * Useful for mocking
 * @returns {Window}
 */
export const openWindow = (...args) => window.open(...args);
/**
 * Get the window location object.
 * Useful for mocking
 * @returns {Location | WorkerLocation}
 */
export const getLocation = () => window.location;
